import { Routes, Route, useLocation } from 'react-router'
import { useEffect } from 'react'
import { Analytics } from '@vercel/analytics/react'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import OnboardingPage from './pages/OnboardingPage'
import DashboardLayout from './pages/DashboardLayout'
import ProtectedRoute from './components/ProtectedRoute'
import GuestRoute from './components/GuestRoute'
import DashboardPage from './pages/dashboard/DashboardPage'
import SearchPage from './pages/dashboard/SearchPage'
import ProjectsPage from './pages/dashboard/ProjectsPage'
import ProjectDetailPage from './pages/dashboard/ProjectDetailPage'
import Gate2Page from './pages/dashboard/Gate2Page'
import Gate2ReadinessPage from './pages/dashboard/Gate2ReadinessPage'
import Gate2RegionalPage from './pages/dashboard/Gate2RegionalPage'
import Gate2TechPage from './pages/dashboard/Gate2TechPage'
import ReportsPage from './pages/dashboard/ReportsPage'
import AnalyticsPage from './pages/dashboard/AnalyticsPage'
import DocsPage from './pages/dashboard/DocsPage'
import SettingsPage from './pages/dashboard/SettingsPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import AcceptInvitePage from './pages/AcceptInvitePage'
import NotFoundPage from './pages/NotFoundPage'
import WaitlistPage from './pages/WaitlistPage'
import VerifyEmailPage from './pages/VerifyEmailPage'

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/waitlist" element={<WaitlistPage />} />
        <Route element={<GuestRoute />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/accept-invite" element={<AcceptInvitePage />} />
        </Route>
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="search" element={<SearchPage />} />
            <Route path="projects" element={<ProjectsPage />} />
            <Route path="projects/:id" element={<ProjectDetailPage />} />
            <Route path="watchlist" element={<ProjectsPage />} />
            <Route path="gate2" element={<Gate2Page />} />
            <Route path="gate2/readiness" element={<Gate2ReadinessPage />} />
            <Route path="gate2/regional" element={<Gate2RegionalPage />} />
            <Route path="gate2/tech" element={<Gate2TechPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="docs" element={<DocsPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Route>
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Analytics />
    </>
  )
}
